import React, { Suspense, lazy } from "react";
import { init } from "@rematch/core";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import Spinner from "./components/@vuexy/spinner/Fallback-spinner";
import * as serviceWorker from "./serviceWorker";
import { IntlProviderWrapper } from "./utility/context/Internationalization";
import { Layout } from "./utility/context/Layout";
import { getPersistor } from "@rematch/persist";
import { PersistGate } from "redux-persist/lib/integration/react";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";

// import * as ReactDOM from "react-dom/client";
import persistPlugin from "@rematch/persist";
import Jobs from "./components/Ceek/Jobs";
import { variants } from "./constants/variants";
import * as models from "./redux";
import authReducers from "./redux/reducers/auth";
import customizerReducer from "./redux/reducers/customizer";
import navbarReducer from "./redux/reducers/navbar/Index";
import "./index.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/index.css";
import Hotjar from "./services/hotjar/hotjar";
import "./styles/custom.css";

//Actions to import and style according to the branch
let ico;
if (window.config.VARIANT === variants.COLORIN) {
  require("./styles/colorin.css");
  ico = require("./assets/img/ico/favicon_colorin.ico");
  document.title = "Comunidad";
} else if (window.config.VARIANT === variants.TERSUAVE) {
  require("./styles/tersuave.css");
  ico = require("./assets/img/ico/favicon_tersuave.ico");
  document.title = "Interactuá";
} else if (window.config.VARIANT === variants.PROVEEDORES) {
  require("./styles/proveedores.css");
  ico = require("./assets/img/ico/favicon_proveedores.ico");
  document.title = "Grupo Disal";
}
document.body.classList.add(window.config.VARIANT);
let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
if (!link) {
  link = document.createElement("link");
  link.rel = "icon";
  document.head.appendChild(link);
}
link.href = ico;

window.config = window.config || {};

const LazyApp = lazy(() => import("./App"));

const configs = {
  storage: storage,
  key: "application",
};

export const store = init({
  // @ts-ignore
  models,
  redux: {
    devtoolOptions: {
      disabled: false, //process.env.REACT_APP_REDUX_DEVTOOLS_DISABLED === "true",
    },
    reducers: {
      customizer: customizerReducer,
      auth: authReducers,
      navbar: navbarReducer,
    },
    middlewares: [thunk],
  },
  plugins: [persistPlugin(configs)],
});
const persistor = getPersistor();

const domNode = document.getElementById("root");
const root = createRoot(domNode);
root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <Hotjar />
      <Suspense fallback={<Spinner />}>
        <Layout>
          <IntlProviderWrapper>
            <LazyApp />
          </IntlProviderWrapper>
        </Layout>
        <Jobs />
      </Suspense>
    </PersistGate>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
